import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { TestLeftMenu, TestProvider } from '../../../test/providers/test-provider';
import { CurrentUser } from '../../../common/providers/current-user';
import { CurrentUserRolesProvider } from '../../../organizations/providers/current-user-roles-provider';
import { ActivatedRoute } from '@angular/router';
import { LangsProvider } from '../../../common/providers/langs-provider';
import { UsersProvider } from '../../../users/providers/users-provider';
import { Subscription } from 'rxjs';
import { Organization } from "../../../common/models/organization";
import { Athlete } from "../../../common/models/athlete";
import { User } from "../../../common/models/user";
import { Test } from "../../../common/models/test";
import { MobilePageContentComponent } from "../../../common/components/mobile-page-content/mobile-page-content";
import { ModuleContentComponent } from "../../../common/components/module-content/module-content";
import { NgIf } from "@angular/common";
import { TestGenericContainerComponent } from "../../../test/pages/generic-container/generic-container.component";
import { MobileSideMenuComponent } from "../../../common/components/mobile-side-menu/mobile.side-menu.component";
import { MobileHeaderComponent } from "../../../common/components/mobile-header/mobile.header";
import { MobileTestSideMenuComponent } from "../side-menu/mobile.side-menu";

@Component({
  selector: 'app-mobile-test-container',
  templateUrl: './mobile.test-container.component.html',
  styleUrls: ['./mobile.test-container.scss'],
  imports: [
    MobilePageContentComponent,
    ModuleContentComponent,
    NgIf,
    TestGenericContainerComponent,
    MobileSideMenuComponent,
    MobileHeaderComponent,
    MobileTestSideMenuComponent
  ],
  standalone: true
})
export class MobileTestContainerComponent implements OnInit, AfterViewInit, OnDestroy {

    public pageTitle = 'Tests';
    public isLoading = true;
    public is401 = false;
    public is404 = false;

    public organization: Organization = {} as Organization;
    public athleteUser: User = {} as User;
    public tests: Test[] = [];
    public test: Test = {} as Test;
    public testsLeftMenu: TestLeftMenu[] = [];
    public activeTestId: number | undefined;

    private subscriptions: Subscription[] = [];

    constructor(
        private currentUser: CurrentUser,
        private currentUserRoles: CurrentUserRolesProvider,
        private route: ActivatedRoute,
        private testProvider: TestProvider,
        private langsProvider: LangsProvider,
        private userProvider: UsersProvider,
    ) {
    }

    public ngOnInit(): void {
        // Load athlete and annual plan if it exists
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => { // { organization: Organization; athlete: Athlete; test: Test }
                if (data.organization) {
                    this.organization = data.organization;
                }

                if (data.athlete) {
                    this.athleteUser = data.athlete;
                }

                if (data.test) {
                    this.test = data.test;
                    this.activeTestId = this.test.id;
                }

                this.loadData();
            })
        );
    }

    public ngAfterViewInit(): void {
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public loadData() {
        this.testProvider.findAllWithMaxDate(this.organization, this.athleteUser, this.langsProvider.getBestLangId()).subscribe({
          next: (tests) => {
            this.testsLeftMenu = tests;
            this.isLoading = false;
          }
        })
    }

    public updateSideMenuEvent() {
        this.loadData();
    }
}
